import { render } from "./files-name-icon.vue?vue&type=template&id=91924494&ts=true"
import script from "./files-name-icon.vue?vue&type=script&lang=ts"
export * from "./files-name-icon.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/00-client-web(prod)/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__